import styled from "styled-components";
import { breakpoints } from "theme/themes";

const StyledNavbar = styled.div`
  display: block;

  > .menu-buttons {
    position: absolute;
    top: 20px;
    right: 16px;
    z-index: 9;

    @media ${breakpoints.medium} {
      right: 32px;
      top: 32px;
    }

    @media ${breakpoints.xl3} {
      top: 50px;
      right: 50px;
    }
  }

  .backdrop {
    pointer-events: none;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9;
    transition: 300ms;
    opacity: ${(props) => (props.isMenuOpen ? "1" : "0")};
    visibility: ${(props) => (props.isMenuOpen ? "visible" : "hidden")};
  }
`;

export default StyledNavbar;
